<template>
  <div class="activities-add-or-update">
    <el-dialog
      title="数据统计"
      :close-on-click-modal="false"
      :visible.sync="activitiesDialog"
      @close="dialogClose"
    >
      <el-tabs
        type="border-card"
        v-model="activeName"
        v-loading="loading"
        @tab-click="handleClick"
      >
        <el-tab-pane name="first" label="地区">
          <span slot="label"><i class="el-icon-s-flag"></i> 地区</span>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="areaName" label="地区"> </el-table-column>
            <el-table-column prop="count" label="人数"> </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="second" label="性别">
          <span slot="label"><i class="el-icon-male"></i> 性别</span>
          <div id="chartPiee" style="width: 640px; height: 400px"></div>
        </el-tab-pane>
        <el-tab-pane name="third" label="平台">
          <span slot="label"><i class="el-icon-date"></i> 平台</span>
          <el-table :data="platform" style="width: 100%">
            <el-table-column prop="type" label="平台类型"> </el-table-column>
            <el-table-column prop="count" label="人数"> </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
import * as echarts from "echarts";
export default {
  data() {
    return {
      activitiesDialog: false,
      activeName: "first",
      chartPie: null,
      loading: false,
      platform: [],
      sexCount: [],
      tableData: [
        // {
        //   date: "2016-05-02",
        //   name: "王小虎",
        //   address: "上海市普陀区金沙江路 1518 弄",
        // },
        // {
        //   date: "2016-05-04",
        //   name: "王小虎",
        //   address: "上海市普陀区金沙江路 1517 弄",
        // },
        // {
        //   date: "2016-05-01",
        //   name: "王小虎",
        //   address: "上海市普陀区金沙江路 1519 弄",
        // },
        // {
        //   date: "2016-05-03",
        //   name: "王小虎",
        //   address: "上海市普陀区金沙江路 1516 弄",
        // },
      ],
    };
  },
  mounted() {
    this.drawCharts();
    // this.getupdata();
  },
  methods: {
    // 初始化？？？
    init(id) {
      console.log(id);
      this.activitiesDialog = true;
      this.$nextTick(() => {
        // this.$refs.activitiesRef.resetFields();
        this.getupdata(id);
      });
    },
    getupdata(id) {
      this.loading = true;
      this.$ajaxGet(
        `/sys/activitiesSignupData/infoStatistic?activityId=${id}`
      ).then((res) => {
        if (res.data.code == 0) {
          this.loading = false;
          console.log(res.data.data);
          this.tableData = res.data.data.area;
          this.platform = res.data.data.platform;
          this.sexCount = res.data.data.sexCount;
        } else {
          this.loading = false;
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      }).catch((error) =>{
          this.loading = false;
           this.$message({
            type: "danger",
            message: error,
          });
      })
    },
    // 关闭弹框时触发事件
    dialogClose() {},
    handleClick(tab, event) {
      console.log(tab, event);
      this.drawCharts();
    },
    //绘制echarts饼状图
    drawPieChart() {
        let a = this.sexCount.manCount
        let b = this.sexCount.womanCount
      // debugger
      this.chartPie = echarts.init(document.getElementById("chartPiee"));
      this.chartPie.setOption({
        title: {
          text: "男女性别统计",
          x: "center",
          y: "10px",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        //设置饼状图每个颜色块的颜色
        color: ["#1a2f68", "orange"],
        legend: {
          itemWidth: 24, // 设置图例图形的宽
          itemHeight: 18,
          orient: "vertical",
          left: "left",
          data: ["男性", "女性"],
        },
        series: [
          {
            name: "数据统计",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: a, name: "男性" },
              { value: b, name: "女性" },
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    drawCharts() {
      this.drawPieChart();
    },
  },
};
</script>

<style lang="less" scoped>
.el-row {
  display: flex;
  align-items: center;
  .el-col {
    display: flex;
    align-items: center;
  }
}
.chart-container {
  width: 100%;
  float: left;
}
.el-col {
  padding: 30px 20px;
}
/deep/ .el-upload-list--picture {
  .el-upload-list__item {
    width: 92px;
    height: 92px;
  }
}
/deep/ .el-date-editor {
  height: 30px;
  line-height: 30px;
}
/deep/ .el-radio__label {
  color: #606266;
}
/deep/ .el-dialog__body {
  .el-form-item {
    margin-bottom: 10px;
  }
}
/deep/ .el-form-item__error {
  padding-top: 0;
}
.el-upload__tip {
  font-size: 12px;
}
.describe-activities {
  padding-top: 5px;
}
</style>